import { React, DomeComponent, AnimatedArray, DomeManipulator } from "@lexriver/dome";
// import cssAnimation from '../Animation.m.scss'
import { BasketRow } from "./BasketRow";
import { GlobalState } from "../GlobalState";
//import { EnumDomeEventDispatcherEvents } from "../EnumDomeEventDispatcherEvents.ts.old";
import { JsonBasketProductInfoWithQuantity } from "../json-data-types/JsonBasketProductInfoWithQuantity";
import { GlobalBasket } from "../GlobalBasket";
// import cssProductsForCategory from './Products.m.scss'
import { JsonBasketRow } from "../json-data-types/JsonBasketRow";
import { LoadingSpinnerForPage } from "./LoadingSpinnerForPage";
import { IBasket } from "../Basket/IBasket";
import css from "./BasketProductList.m.scss"

interface Attrs{
    scrollToProductId:number
}

export class BasketProductList extends DomeComponent<Attrs>{
    animatedArray = new AnimatedArray<JsonBasketRow>({
        //animationHide:undefined,
        //animationHide:{cssClassName:cssAnimation.fadeOutTest, timeMs:10000},
        //animationShow:{cssClassName:cssAnimation.fadeIn1000, timeMs:1000},
        array: [],
        getKey: (x:JsonBasketRow) => JSON.stringify({productId:x.product.id, attributes:x.productChosenAttributes}),
        getHtmlElement: (x:JsonBasketRow) => {
            //const quantity = GlobalState.getCurrentBasket().getQuantity(x)
            //console.log('##### getHTMLElement')
            //console.log('# BasketProductList rendering item', x)
            return <BasketRow basketRow={x} scrollIntoView={x.product.id===this.attrs.scrollToProductId} />
        },
        emptyList:<LoadingSpinnerForPage />

        //parentElement: this.rootElement
    })

    // init(){
    // }

    render(){
        //console.log('# BasketProductList', 'render()')
        return <div class={css.container}></div>
    }

    async afterRender(){
        this.animatedArray.update([], this.rootElement) //show empty
        
        //console.log('this.rootElement=', this.rootElement, 'IsInDom=', DomeManipulator.isInDom(this.rootElement))
        //console.log('@@@ subscribing for BasketProductList')
        GlobalBasket.onBasketUpdateEvent.subscribe(async () => {
            if(!DomeManipulator.isInDom(this.rootElement)) return {unsubscribe:true}
            const basket:IBasket = await GlobalBasket.getCurrentBasketAsync()
            this.animatedArray.update(await basket.getListOfRowsAsync(), this.rootElement)
        })

        GlobalBasket.onBasketCouponChangeEvent.subscribe(async () => {
            if(!DomeManipulator.isInDom(this.rootElement)) {
                //console.log('BasketRow.tsx', 'unsubscribe!')
                return {unsubscribe:true}
            }
            //await DomeManipulator.hideElementAsync(this.refLoading)
            const basket:IBasket = await GlobalBasket.getCurrentBasketAsync()
            this.animatedArray.update(await basket.getListOfRowsAsync(), this.rootElement)

        })
        

        const basket:IBasket = await GlobalBasket.getCurrentBasketAsync()
        this.animatedArray.update(await basket.getListOfRowsAsync(), this.rootElement)
    }
}